var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "130px"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "办事指南标题", prop: "title" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: {
                          type: "text",
                          clearable: "",
                          placeholder: "请输入办事指南标题",
                          disabled: _vm.isDetail
                        },
                        model: {
                          value: _vm.childData.title,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "title", $$v)
                          },
                          expression: "childData.title"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "办事指南摘要", prop: "remark" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: {
                          type: "textarea",
                          maxlength: "20",
                          clearable: "",
                          placeholder: "请输入办事指南摘要",
                          disabled: _vm.isDetail
                        },
                        model: {
                          value: _vm.childData.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "remark", $$v)
                          },
                          expression: "childData.remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "required",
                      attrs: { label: "办事指南内容" }
                    },
                    [
                      _c("Tinymce", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isDetail,
                            expression: "!isDetail"
                          }
                        ],
                        ref: "editor",
                        attrs: { menubar: !_vm.isDetail, height: 350 },
                        model: {
                          value: _vm.childData.content,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "content", $$v)
                          },
                          expression: "childData.content"
                        }
                      }),
                      _c("Tinymce", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isDetail,
                            expression: "isDetail"
                          }
                        ],
                        ref: "viewer",
                        staticStyle: { width: "580px" },
                        attrs: {
                          height: 350,
                          menubar: false,
                          toolbar: _vm.toolbar,
                          readonly: _vm.readonly
                        },
                        model: {
                          value: _vm.childData.content,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "content", $$v)
                          },
                          expression: "childData.content"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          !_vm.isDetail
            ? _c("el-button", { on: { click: _vm.handCancle } }, [
                _vm._v(_vm._s(_vm.$t("button.cancel")))
              ])
            : _vm._e(),
          !_vm.isDetail
            ? _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
                [_vm._v(_vm._s(_vm.$t("button.confirm")))]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }